// const initialState = {

// }

// const viewEmployeeReducer = (state = initialState , action ) => {
//     const newState = {...state}
//     switch (key) {
//         case value:
            
//             break;
    
//         default:
//             break;
//     }
// }

// export default viewEmployeeReducer;


// WEBPACK FOOTER //
// ./src/reducers/viewEmployeeReducer.js